import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import Select from "../../shared/InputElements/Select";
import { useIntl } from "react-intl";

const SelectPlugType = ({ id = "select-charger-brand-filter", chargers, ...rest }) => {
     const intl = useIntl();
     const userPrefs = useContext(UserPrefsContext);
     const label = intl.formatMessage
          ? intl.formatMessage({ id: "plugType", defaultMessage: "Plug Type" })
          : "Plug Type";

     const optionNames = ["J1772", "CCS1", "Tesla", "NACS", intl.formatMessage({ id: "all", defaultMessage: "All" })];

     const optionValues = ["J1772", "CCS1", "Tesla", "NACS", "all"];

     return (
          <Select
               id={id}
               value={userPrefs.get("chargerPlugTypeFilter")}
               label={label}
               optionNames={optionNames}
               optionValues={optionValues}
               handler={(e) => userPrefs.set({ chargerPlugTypeFilter: e.target.value })}
          />
     );
};

export default SelectPlugType;

SelectPlugType.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
};
